import $ from 'jquery';
import _ from 'lodash';
import {SisName} from 'util/SisName'
import {EntryDescStateType} from 'module/edesc/reducer/EntryDescReducer'
import {EntryDesc} from 'generated/JavaTOmodifications'
import {CustomFieldTO} from 'generated/JavaTO'
import {EventDialogModel} from 'module/EventDialog/type/EventDialogType'
import {BSModelType} from 'module/BSCollection/type/BSCollectionStateType'

/**
 * @typedef CFInputType CFInputType
 * @readonly
 * @enum {number}
 */
export enum CFInputType {
	DropDownNumberPad = 0,
	Autocomplete = 1,
	AutocompleteValueLabel = 2,
	AutocompleteValueList = 3,
	DqButtons = 4,
	DqConvert = 5,
	DqLabel = 6,
}

/**
 * defines the color of the booking (in list means uses normal colors, not in list uses terminal colors)
 * @type {string[]} case sensitive
 */
let APP_DEVICES: string[] // server property / default value
export const fetchAppDeviceStrings = () => {
	return $.ajax({url: "../json/property/devices"}).done(function (response) {
		APP_DEVICES = response
		Object.freeze(APP_DEVICES)
	})
}

export const isAppDevice = (dev?: string) => {
	return _.includes(APP_DEVICES, dev);
}

export const isTerminalDevice = (dev?: string) => {
	return !isAppDevice(dev);
}

export const getEntryDescColorObj = (entryDesc: EntryDesc, dev?: string) => {
	return isTerminalDevice(dev) ? entryDesc.terminalColor : entryDesc.typeColor;
}

export const CFInputParameter = {
	evoApps: {
		0: {
			1: 'evoApps: ',
		},
		1: {
			0: '',
			1: 'Ziffernblock + P',
			2: 'Ziffernblock',
			3: 'Telefonziffernblock',
			4: 'Ziffernblock + :',
		},
		2: {
			0: '',
			1: 'Combobox mit Auswahl, Label',
			2: 'Combobox mit Label',
			3: 'Combobox mit Auswahl',
			4: 'nur Datenqellen-Validierung',
			B: 'Buttons statt Inputfeld/Combobox',
			X: 'dq konvertiert label zu value',
			L: 'nur label',
		},
		3: {
			0: '',
			1: 'mit Buffer',
		},
	},
	MobileTimer: {
		'0010': 'Eingabe oder Auswahl',
		'0011': 'nur Auswahl',
		'0020': '(Eingabe oder Auswahl) oder Scan',
		'0021': 'nur Auswahl oder Scan (RFID oder Barcode)',
		'0030': '(Eingabe oder Auswahl) oder Scan (nur RFID)',
		'0031': 'nur Auswahl oder Scan (nur RFID)',
		'0040': '(Eingabe oder Auswahl) oder Scan (nur Barcode)',
		'0041': 'nur Auswahl oder Scan (nur Barcode)',
		'0050': 'Scan (RFID oder Barcode)',
		'0051': 'Scan (nur RFID)',
		'0052': 'Scan (nur Barcode)',
		'0060': 'CheckBox  (J/[N])',
		'0061': 'CheckBox  (J/[N])  -> bei J Bemerkung zwingend',
		'0062': 'CheckBox  (J/[N])  -> bei N Bemerkung zwingend',
		'0070': 'RadioButton (J/N) – nichts vorausgewählt',
		'0071': 'RadioButton (J/N) -> bei J Bemerkung zwingend',
		'0072': 'RadioButton (J/N) -> bei N Bemerkung zwingend',
		'0080': 'Unterschrift',
		'0090': 'Foto',
		'0100': 'Einlesen von QR-Codes mit Werten für mehrere Eingabefelder',
	},
};

export const hasCFInputFeature = (cfDef: CustomFieldTO, cfInputType: CFInputType) => {
	if (!cfDef) return false;
	const inp = (cfDef.input || '') + '';
	//app
	if (inp[0] !== '1') return false;
	switch (cfInputType) {
		case CFInputType.DropDownNumberPad:
			if (+inp[1] > 0) return true;
			break;
		case CFInputType.Autocomplete:
			if (+inp[2] > 0 && +inp[2] < 5) return true;
			break;
		case CFInputType.AutocompleteValueLabel:
			if (inp[2] === '1' || inp[2] === '2') return true;
			break;
		case CFInputType.AutocompleteValueList:
			if (inp[2] === '1' || inp[2] === '3') return true;
			break;
		case CFInputType.DqButtons:
			if (inp[2] === 'B') return true;
			break;
		case CFInputType.DqConvert:
			if (inp[2] === 'X') return true;
			break;
		case CFInputType.DqLabel: //todo
			if (inp[2] === 'L') return true;
			break;
	}
	return false;
};

//redux util
type EntryDescById = EntryDescStateType['EntryDesc']['byId']

export function findEntryDescForModel<T extends EventDialogModel>(entryDescById: EntryDescById, attr: any) {
	if (!attr || _.isEmpty(entryDescById)) return undefined;
	let {bookingType, hourCategory} = attr;
	bookingType = _.trim(bookingType) || ' ';
	hourCategory = _.trim(hourCategory) || ' ';
	return _.find(entryDescById, {bookingType, hourCategory});
}

export function transformBSToEntryDescId(entryDescById: EntryDescById, attr: BSModelType | null): BSModelType | null {
	if (!attr) return attr
	const sisName = attr?.sisName
	if (sisName !== SisName.Booking && sisName !== SisName.Persurl) return attr
	// @ts-ignore because Persurl has no bookingType
	const {bookingType, hourCategory, ...attrFiltered} = attr
	const ed = findEntryDescForModel(entryDescById, {bookingType, hourCategory})
	return {...attrFiltered, _edId: ed && ed.id || NaN} as BSModelType
}

export function transformEntryDescIdToBS(entryDescById: EntryDescById, attr?: null | { _edId?: number }) {
	if (!attr || !attr.hasOwnProperty('_edId')) return attr
	const {_edId} = attr
	const {bookingType, hourCategory} = _edId && entryDescById[_edId] || {}
	return {...attr, bookingType, hourCategory}
}